import { makeStyles } from '@mui/styles';

const useReportsTableRowStyle = makeStyles(() => ({
  table: {
    minWidth: 650,
  },
  duplicateBtn: {
    marginRight: '10px !important',
    width: 96,
  },
  tableHeader: {
    fontSize: '20px !important',
    fontWeight: 'bold',
  },
  tableCell: {
    fontSize: '16px !important',
  },
  btn: {
    width: 96,
  },
  archivedText: {
    color: '#f50057',
  },
  btnCell: {
    width: '195px',
  },
}));

export default useReportsTableRowStyle;
